import { lazy } from 'react';

import {
	createRootRoute,
	createRouter,
	createRoute,
	AnyRoute,
	Outlet,
} from '@tanstack/react-router';

import { basepath } from '@/constants';
import config from '@/config';
import { NotFound } from '@/views/RootRoute';
import { issueSearchSchema } from '@/views/issue/Issue.hooks';
import { SessionTracker } from '@/components/session/SessionTracker';
import { DevTools } from '@/components/DevTools';

// Lazy loaded routes
const LazyHome = lazy(() => import('./home/Home'));
const LazyPreview = lazy(() => import('@/templates/daily/preview/Preview'));
const LazyDrafts = lazy(() => import('@/views/drafts/Drafts'));
const LazyIssue = lazy(() => import('./issue/Issue'));
import { getRoute as getArticleRoute } from '@views/article/Article.route';
import { TrackingView } from './tracker/Tracker';

const rootRoute = createRootRoute({
	component: RootRouteComponent,
});

/* Routes declaration */

const indexRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: '/',
	component: LazyHome,
});

const issueRoute = createRoute({
	getParentRoute: () => rootRoute,
	component: LazyIssue,
	validateSearch: issueSearchSchema,
	path: 'issues/$id',
});

const issueArticleRoute = createRoute({
	getParentRoute: () => issueRoute,
	validateSearch: issueSearchSchema,
	component: LazyIssue,
	path: '$articleId',
});

const previewRoute = createRoute({
	getParentRoute: () => rootRoute,
	component: LazyPreview,
	path: 'preview/$id',
});

const draftsRoute = createRoute({
	getParentRoute: () => rootRoute,
	component: LazyDrafts,
	path: 'drafts',
});

const trackerRoute = createRoute({
	getParentRoute: () => rootRoute,
	component: TrackingView,
	path: 'track',
});

const articleRoute = getArticleRoute({
	parentRoute: rootRoute,
});

/* END of routes declaration */

const routes: Array<AnyRoute> = [
	indexRoute,
	issueRoute,
	issueArticleRoute,
	previewRoute,
	trackerRoute,
	articleRoute,
];

if (config?.app?.admin) {
	routes.push(draftsRoute);
}

const routeTree = rootRoute.addChildren(routes);

export const router = createRouter({
	routeTree,
	basepath,
	defaultNotFoundComponent: NotFound,
});

function RootRouteComponent() {
	// useNavigationHistory();
	return (
		<>
			<SessionTracker />
			<Outlet />

			<DevTools router={router} />
		</>
	);
}
